export default "__VITE_ASSET__xk$acJWT__"